import PageBannerCard from '@shared/components/core/card/PageBannerCard';
import { useTranslation } from 'react-i18next';

export default function OrgProductEmptyBanner() {
    const { t } = useTranslation();

    return (
        <PageBannerCard
            description={t('common:license.key.product.empty.description')}
            fullHeight
            title={t('common:license.key.product.empty.title')}></PageBannerCard>
    );
}
